export default class Specialization {
    bgColor() {
        return this.color ? this.color : '#888888';
    }
}